module.exports = __webpack_public_path__ + "img/logo-gerer-mon-LMNP.5159b8a2.png";